<!-- checkOut -->
<template>
  <div class="checkOut" :class="{ inApp: $root.$data.isApp }">
    <common-title titleName="代付款" :zIndex="1000"></common-title>
    <van-loading
      class="checkOutLoading"
      color="#ff6c02"
      size="60px"
      text-size="18px"
      vertical
      v-if="statusLoading"
    >
      支付状态确认中...
    </van-loading>
    <template v-else>
      <template v-if="loading">
        <commonLoading />
      </template>
      <template v-else>
        <template v-if="isWap">
          <div></div>
        </template>
        <template v-else>
          <template v-if="isOpen">
            <div style="width: 100%; text-align: center">
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pay_err.png"
                alt=""
                class="payError"
              />
            </div>
            <p class="payError-tip">
              {{
                orderStatusMap[orderStatus] ? `该订单${orderStatusMap[orderStatus]}，` : ''
              }}付款链接已失效，若还需购买课程请重新下单哦
            </p>
            <div @click="goHone" class="btn-back">返回首页</div>
          </template>
          <template v-else>
            <section class="payNum">
              <p>
                ￥<span>{{ orderAmount }}</span>
              </p>
              <p>
                剩余支付时间<span>{{ countdown }}</span>
              </p>
            </section>
            <section class="payInfo">
              <p class="sectionTitle">选择支付方式</p>
              <pay-methods-list
                :payMethodsList="payMethodsListData"
                :huabeiList="huabeiList"
                :baitiaoList="baitiaoList"
              />
            </section>
            <section class="orderDetail">
              <div class="orderDetail-header">代付订单信息</div>
              <div class="orderDetail-item" v-for="(item, index) in productList" :key="index">
                <div class="orderDetail-name">{{ item.productName }}</div>
                <div class="orderDetail-sku">{{ item.skuName }}</div>
              </div>
            </section>
            <section class="pay-agreement">
              <span :class="['payProtocol', { payProtocolActive }]" @click="protocolActiveChange">
                已同意
              </span>
              <template v-if="agreementList.length > 0">
                <span
                  v-for="(item, index) in agreementList"
                  :key="index"
                  @click="showqihangAgree(item)"
                >
                  《{{ item.name }}》<span v-if="index < agreementList.length - 1">、</span>
                </span>
              </template>
              <span v-else @click="goPage()"
                >《{{ '用户购买协议' }}》</span
              >
            </section>
            <section class="bottomButton">
              <button
                @click="pay"
                :class="
                !(payProtocolActive && payMethodsListData.find((payMethod) => payMethod.active))
                ? 'buttonUnactive'
                : ''
            "
              >
                立即支付 ￥{{ orderAmount }}
              </button>
            </section>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { setBaseUrl, copyTool, getWechatAppId, invalidTimeCount } from '@/utils/tools';
import commonLoading from '@/components/commonComponents/CommonLoading.vue';

import {
  payIcons,
  payTypeMap,
  HUABEI_TYPE,
  HUABEI_TYPE_ID,
  BAITIAO_TYPE,
  BAITIAO_TYPE_ID,
} from '@/assets/js/payConfig';
import {
  reqPayInfo,
  reqHuabeiInfo,
  reqOrderValidation,
  reqPayImmediate,
  reqPayResult,
} from '@/api/othersPay';
import payMethodsList from '../payment/checkOutComponents/payMethodsList.vue';

export default {
  data() {
    return {
      source: Number(this.$route.query.source), // 1 退换课来源 2 拼团  3 定金 4 定金尾款
      isOrderAddres: this.$route.query.isOrderAddres,
      orderAmount: 0,
      discountAmount: 0,
      proxyOrderNo: '',
      // tokenMoneyTotal: 50,
      payMethodsListData: [],
      huabeiList: [],
      baitiaoList: [],
      statusLoading: false,
      timer: null, // 定时器
      wxCode: null, // 微信授权的code
      loading: false,
      groupId: '',
      depositStatus: 0, // 定金单当前状态 1-待付定金 2-定金单已取消 3-定金单超时关闭 4-待付尾款（已付定金） 5-尾款已支付 6-尾款已关闭（超时未支付）
      point: false,
      isOpen: false, // 订单开启状态
      orderStatus: null,
      orderStatusMap: {
        2: '已支付成功',
        3: '已支付成功',
        4: '已取消',
        5: '已关闭',
      },
      productList: [],
      countdownTimer: null,
      countdown: '',
      remainingPaymentTime: 0,
      isWap: false,
      payProtocolActive: false,
      agreementList: [],
    };
  },
  components: {
    payMethodsList,
    commonLoading,
  },
  async mounted() {
    const UserClient = navigator.userAgent.toLowerCase();
    const isWapClient =
      /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|ohos|HarmonyOS|ArkWeb/i.test(
        UserClient,
      );
    if (!isWapClient) {
      this.isWap = !isWapClient;
      return;
    }
    this.loading = true;
    this.proxyOrderNo = this.$route.query.proxyOrderNo;
    // 订单校验
    const isContinue = await this.orderValid();
    if (!isContinue) return;
    // 进入页面查询支付结果，免费课直接跳转
    await this.payStatusConfirm();
    await this.payInfoInit();
    if (this.$route.query.needConfirm) {
      this.processConfirm();
    }
    if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
      this.wxCode = this.$route.query.code;
      this.pay();
    }
  },
  methods: {
    goHone() {
      this.$router.push({ name: 'home' });
    },
    protocolActiveChange() {
      this.payProtocolActive = !this.payProtocolActive;
    },

    goPage() {
      this.$router.push({ name: 'payAgreement' });
    },

    showqihangAgree(item) {
      const itemStr = encodeURIComponent(JSON.stringify(item));
      this.$router.push({
        path: 'qihangSchoolAgreementDetail',
        query: {
          xieyiInfo: itemStr
        },
      });
    },

    wxpay(val) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(val), false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(val));
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(val));
        }
      } else {
        this.onBridgeReady(val);
      }
    },

    onBridgeReady(val) {
      const that = this;
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: val.appid, // 公众号名称，由商户传入
          timeStamp: `${val.timeStamp}`, // 时间戳，自1970年以来的秒数
          nonceStr: val.nonceStr, // 随机串
          package: val.packages,
          signType: val.signType, // 微信签名方式:
          paySign: val.paySign, // 微信签名
        },
        (res) => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            that.$router.replace({
              path: '/othersPay/paySuccess',
              query: { proxyOrderNo: this.$route.query.proxyOrderNo },
            });
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            this.$toast('支付失败...');
            if (this.$root.$data.isWeiXin) {
              this.$router.replace({
                path: '/othersPay',
                query: {
                  proxyOrderNo: this.$route.query.proxyOrderNo,
                },
              });
            }
          }
        },
      );
    },
    // 支付校验--是否有购买过的商品
    async orderValid() {
      // if (this.$route.query.needConfirm) return;

      const response = await reqOrderValidation({
        proxyOrderNo: this.proxyOrderNo,
      });
      let isContinue = 1;
      if (response?.code) {
        this.loading = false;
        this.isOpen = true;
      } else if (response?.data?.status !== 1) {
        this.isOpen = true;
        this.orderStatus = response?.data?.status;
        if (response?.data?.status === 3) {
          isContinue = 0;
          this.loading = false;
        }
      } else if (response?.data?.repeatBuyProductNameList?.length) {
        this.$toast(
          `订单内商品${response?.data?.repeatBuyProductNameList?.join()}不能重复购买，请重新下单`,
        );
      }
      // eslint-disable-next-line consistent-return
      return isContinue;
    },
    // 查询订单信息
    async payInfoInit() {
      const response = await reqPayInfo({
        proxyOrderNo: this.proxyOrderNo,
      });
      this.loading = false;
      if (response?.code) {
        this.$toast('支付信息初始化失败');
      } else {
        // console.log(response, 666);
        const responseData = response?.data || {};
        this.remainingPaymentTime = response?.remainingPaymentTime || 0;
        console.log('remainingPaymentTime', responseData?.remainingPaymentTime || 0);
        this.setTimeoutTimer(responseData?.remainingPaymentTime);
        Object.assign(this, responseData);
        const payList = [20, 30, 10, 50];
        const payType = responseData?.payTypeList || [];
        payType.sort((a, b) => payList.indexOf(a) - payList.indexOf(b));
        const payTypeIds = payType;
        this.productList = responseData.productList;
        const huabeiValid =
          payTypeIds.some((payTypeId) => payTypeId === HUABEI_TYPE_ID) && this.orderAmount >= 100;
        const jdValid = payTypeIds.some((payTypeId) => payTypeId === BAITIAO_TYPE_ID);
        this.agreementList = responseData?.agreementList || [];
        this.payMethodsListData = payTypeIds
          .filter((payTypeId) => this.orderAmount >= 100 || payTypeId !== HUABEI_TYPE_ID)
          .map((payTypeId, payTypeIndex) => ({
            icon: payIcons[payTypeId],
            type: payTypeMap[payTypeId],
            active: this.$root.$data.isWeiXin ? payTypeId === 10 : !payTypeIndex,
          }));
        if (huabeiValid || jdValid) {
          this.huabeiInit();
        }
      }
    },
    processConfirm() {
      this.$dialog
        .confirm({
          title: '是否已完成支付',
          confirmButtonText: '已完成支付',
          cancelButtonText: '尚未支付',
        })
        .then(() => {
          this.statusLoading = true;
          this.loopPayStatus();
          // this.payStatusConfirm();
        })
        .catch(() => {});
    },
    loopPayStatus() {
      let count = 0;
      this.timer = setInterval(() => {
        count += 1;
        if (count > 5) {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
          this.statusLoading = false;
          this.$toast('订单状态确认有误，请重新支付');
        }
        this.payStatusConfirm('loop');
      }, 1000);
    },
    async payStatusConfirm(source) {
      const { proxyOrderNo } = this;
      const response = await reqPayResult({
        proxyOrderNo,
      });
      if (response?.code) {
        throw new Error(response?.msg);
      }
      if (response.code === 0 && this.source === 2) {
        this.groupId = response.data.groupId;
      }
      if (
        response?.data?.changeStatus === 4 ||
        response?.data?.paySuccess ||
        response?.data?.groupOrderStatus >= 2 ||
        (response?.data?.depositPayResult === 1 && this.source === 3) ||
        (response?.data?.balancePayResult === 1 && this.source === 4)
      ) {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
        this.$router.replace({
          path: '/othersPay/paySuccess',
        });
      }
    },
    huabeiInit() {
      reqHuabeiInfo({
        payAmount: this.orderAmount,
      }).then((response) => {
        if (response?.code) {
          this.$toast('花呗信息初始化失败');
        } else {
          const huabeiData = response?.data || {};
          this.huabeiList = huabeiData?.huaBeiPayableRespVOList || [];
          this.baitiaoList = huabeiData?.huaBeiPayableRespVOList || [];
        }
      });
    },
    methodSelect(selectedPayMethod) {
      this.payMethodsList.forEach((payMethod) => {
        Object.assign(payMethod, { active: false });
      });
      Object.assign(selectedPayMethod, { active: true });
    },
    async pay() {
      if (!this.payProtocolActive) {
        this.$toast(`您未勾选购买协议`);
        return;
      }
      const payType = this.payMethodsListData.find((payMethod) => payMethod.active);
      const payMethod = Number(
        Object.entries(payTypeMap).find((keyValue) => keyValue[1] === payType.type)[0],
      );
      // 白条
      const isChooseBaiTiao =
        payType.type === BAITIAO_TYPE
          ? Number(
              (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {}).payableNum,
            )
          : undefined;
      let payment = payMethod === 10 ? payMethod + 1 : payMethod + 2;

      if (isChooseBaiTiao) {
        payment = isChooseBaiTiao && this.$root.$data.isApp ? 52 : 53;
      }
      if (this.point) return;
      this.point = true;

      const wechatAppId = await getWechatAppId('pay');
      let response = null;
      this.loading = true;

      if (this.$root.$data.isWeiXin && !isChooseBaiTiao) {
        // 在微信客户端时使用微信公众号授权并调起支付
        // 在获取到当前url为微信重定向后的链接时，调用支付接口
        // source 1：退换课 2：拼团 3 定金 4 定金尾款
        if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
          response = await reqPayImmediate({
            appId: wechatAppId,
            wxCode: this.wxCode,
            proxyOrderNo: this.proxyOrderNo,
            payment: 12,
            platform: 1,
            usedBalanceAmount: 0,
            usedBalanceOnlyStatus: 0,
            usedBalanceStatus: 0,
          });
        } else {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatAppId}&redirect_uri=${setBaseUrl(
            'default',
          )}/ark/othersPay?proxyOrderNo=${this.$route.query.proxyOrderNo}%26source=${
            this.$route.query.source
          }&response_type=code&scope=snsapi_base&state=weixinredirect&connect_redirect=1#wechat_redirect`;
        }
      } else {
        response = await reqPayImmediate({
          // hbFqSellerPercent: 'string',
          hbfqNum:
            payType.type === HUABEI_TYPE
              ? Number(
                  (this.huabeiList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          btfqNum:
            payType.type === BAITIAO_TYPE
              ? Number(
                  (this.baitiaoList.find((huabeiPayMethod) => huabeiPayMethod.active) || {})
                    .payableNum,
                )
              : undefined,
          proxyOrderNo: this.proxyOrderNo,
          payment,
          platform: 1,
          usedBalanceAmount: 0,
          usedBalanceOnlyStatus: 0,
          usedBalanceStatus: 0,
        });
      }

      this.loading = false;
      this.point = false;
      console.log('response', response);
      // 但在微信浏览器环境且当前页面不是回调页面时，中断方法
      if (this.$root.$data.isWeiXin && !this.$route.query.code && !isChooseBaiTiao) {
        return;
      }
      // 微信浏览器环境调起微信支付
      if (this.$root.$data.isWeiXin && !isChooseBaiTiao) {
        if (response.code === 0) {
          this.wxpay(response.data.unifyPayRespVO.result);
        }
        return;
      }
      if (response?.code) {
        this.$toast(`因${response?.msg}，支付失败`);
      } else if (response?.data?.unifyPayRespVO?.wapUrl || response?.data?.unifyPayRespVO?.qrCode) {
        const { wapUrl, qrCode } = response?.data?.unifyPayRespVO;
        const backUrl = window.encodeURIComponent(`${window.location.href}&needConfirm=true`);
        // 支付时，先拼接可以弹出支付弹窗的路由
        const { ...query } = this.$route.query;
        await this.$router.replace({ query: { ...query, needConfirm: true } });
        window.location.href = `${wapUrl || qrCode}${
          payMethod === 10 ? `&redirect_url=${backUrl}` : ''
        }`;
        setTimeout(() => {
          this.processConfirm();
        }, 2000);
      } else {
        this.$toast('跳转失败，请联系管理员');
      }
    },
    // 浏览倒计时
    setTimeoutTimer(time) {
      const broswerTimes = time;
      this.countdown = invalidTimeCount(broswerTimes);
      clearTimeout(this.countdownTimer);
      this.countdownTimer = null;
      if (broswerTimes <= 0) return;
      this.countdownTimer = setTimeout(() => {
        this.setTimeoutTimer(broswerTimes - 1);
      }, 1000);
    },
  },
  destroyed() {
    sessionStorage.removeItem('payable');
  },
};
</script>

<style lang="scss" scoped>
.checkOut {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 240px;
  background: #f9f9f9;
  user-select: none;

  .checkOutLoading {
    margin-top: 100px;

    .van-loading__text {
      margin-top: 20px;
    }
  }

  .orderInfo {
    margin-bottom: 47px;

    .orderPrice {
      padding: 47px 0 14px;
      color: #333;
      font-weight: bold;
      font-size: 43px;
      text-align: center;
    }

    .orderDiscount,
    .orderNo {
      font-size: 25px;
      text-align: center;

      .text {
        color: #787878;
        user-select: unset;
      }
    }

    .orderDiscount {
      margin-bottom: 18px;

      .price {
        color: #ff6c02;
      }
    }

    .orderNo {
      display: flex;
      align-items: center;
      justify-content: center;

      .copyButton {
        width: 43px;
        height: 43px;
        background: url('../../assets/img/payment/copy_button.png') no-repeat center;
        background-size: contain;
      }
    }
  }

  .payInfo {
    width: 100%;
    padding: 0 36px;
    background: #fff;
    border-radius: 4px;

    .sectionTitle {
      height: 98px;
      font-weight: bold;
      font-size: 29px;
      line-height: 98px;
      border-bottom: 2px solid #f5f5f6;
    }
  }

  .pay-agreement {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-top: 36px;
    margin-right: 36px;

    span {
      color: #787878;
      font-size: 22px;
      line-height: 36px;

      // &:last-child {
      //   text-decoration: underline;
      // }
    }
  }

  .payProtocol {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    // padding: 36px 36px 243px 0;
    color: #787878;
    font-size: 22px;
    line-height: 36px;
    text-align: right;

    a {
      text-decoration: underline;
    }

    &::after {
      display: inline-block;
      width: 29px;
      height: 29px;
      background: url('../../assets/img/payment/unselect.png') no-repeat center center;
      background-size: contain;
      content: '';
    }

    &Active::after {
      background-image: url('../../assets/img/payment/selected.png');
    }
  }

  .handsel {
    position: fixed;
    right: 0;
    bottom: 150px;
    left: 0;
    color: #ff6c02;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
  }

  .bottomButton {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    background: #fff;

    .customerService {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 74px;
      color: #ff6c02;
      font-size: 22px;
      line-height: 74px;
      text-align: center;
      background: rgba(255, 108, 2, 0.1);
      cursor: pointer;

      .customerServiceIcon {
        display: inline-block;
        width: 43px;
        height: 43px;
        margin-left: -7px;
        background: url('../../assets/img/payment/go_service.png') no-repeat center;
        background-size: contain;
      }
    }

    button {
      height: 84px;
      margin: 20px 36px;
      color: #fff;
      font-size: 29px;
      line-height: 84px;
      background: #ff6c02;
      border-radius: 41px;
      cursor: pointer;

      &.buttonUnactive {
        background: #ccc;
      }
    }
  }

  .payNum {
    p {
      text-align: center;

      &:nth-child(1) {
        height: 60px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 43px;
        color: #ff3938;
        line-height: 60px;
        font-style: normal;
        margin: 47px 0 14px;
      }

      &:nth-child(2) {
        height: 36px;
        font-family: PingFangSC, PingFang SC;
        font-size: 25px;
        color: #999999;
        line-height: 36px;
        margin-bottom: 43px;

        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #ff7f41;
          line-height: 36px;
        }
      }
    }
  }

  .orderDetail {
    background-color: #fefefe;
    margin-top: 22px;
    padding: 0 36px;

    &-header {
      padding: 29px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;
      text-align: left;
      font-style: normal;
    }

    &-item {
      padding: 29px 0;
      border-top: 2px solid #f5f5f5;
    }

    &-name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      line-height: 36px;
      text-align: left;
      font-style: normal;
    }

    &-sku {
      margin-top: 11px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #999999;
      line-height: 36px;
      text-align: left;
      font-style: normal;
    }
  }

  .payError {
    display: inline-block;
    height: 217px;
    width: 368px;
    margin: 330px 0 14px;

    &-tip {
      margin: 0 auto;
      width: 514px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 25px;
      color: #999999;
      line-height: 36px;
      text-align: center;
      font-style: normal;
    }
  }

  .btn-back {
    width: 283px;
    height: 80px;
    background: #ff7f41;
    border-radius: 41px;
    margin: 80px auto;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 29px;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
    font-style: normal;
  }
}

.inApp {
  padding-top: 0;
}
</style>
